import type { ConfigTVCCDTO, NuovoConfigTVCCDTO } from '@/models/dto/plc/config-tvcc-dto'
import type { NewPhotoConfiguration, PhotoConfiguration } from '@/models/types/plc/photo-configuration'

const mapToPhotoConfiguration = (
    configTVCCDto: ConfigTVCCDTO | NuovoConfigTVCCDTO,
): PhotoConfiguration | NewPhotoConfiguration => {
    if ('id' in configTVCCDto) {
        return {
            id: configTVCCDto.id,
            time: configTVCCDto.time ?? undefined,
        }
    }
    return {
        time: configTVCCDto.time ?? undefined,
    }
}

const mapToConfigTVCCDto = (
    tvccConfiguration: NewPhotoConfiguration | PhotoConfiguration,
): NuovoConfigTVCCDTO | ConfigTVCCDTO => {
    if ('id' in tvccConfiguration) {
        return {
            id: tvccConfiguration.id,
            time: tvccConfiguration.time ?? null,
        }
    }
    return {
        time: tvccConfiguration.time ?? null,
    }
}

export { mapToConfigTVCCDto, mapToPhotoConfiguration }
